<template>
  <div>
    <div class="header mb-10">
      <el-button
        @click="startItemEditor()"
        type="primary"
        icon="el-icon-plus"
        size="small"
        v-permission="Auth.productNew"
        >新增零件</el-button
      >
      <file-button
        style="float: right"
        class="mobile-hide"
        obj="item"
        :filter="filter"
        @importCallback="requestItemList"
        v-permission="Auth.productIE"
      ></file-button>
    </div>
    <el-table
      v-loading="loading"
      :data="lists"
      stripe
      ref="table"
      header-row-class-name="q-products-header"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="44"> </el-table-column>
      <el-table-column prop="name" label="名称/件号">
        <template slot-scope="scope">
          <div>{{ scope.row.name }}</div>
          <div>{{ scope.row.part_number }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="item_category.name" label="供应商/分类">
        <template slot-scope="scope">
          <div v-if="userInfo.dealer_id > 0">
            {{
              scope.row.dealer_id == 0 ? '阿特拉斯' : scope.row.supplier.name
            }}
          </div>
          <div>
            {{ scope.row.item_category.whole_name.replace(/,/g, ' - ') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="machine_type"
        label="机型"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <template v-for="item in scope.row.machine_type.split(',')">
            {{ item }}
            <br />
          </template>
        </template>
      </el-table-column>
      <el-table-column label="成本价" align="center" width="120">
        <template slot-scope="scope">{{
          scope.row.cost_price.price.toFixed(2)
        }}</template>
      </el-table-column>
      <el-table-column label="定价" align="center" width="120">
        <template slot-scope="scope">{{ scope.row.price.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column prop="description" label="描述"></el-table-column>
      <el-table-column align="right" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            class="mr-10"
            @click="startItemEditor(scope.row, scope.$index)"
            v-if="scope.row.dealer_id == userInfo.dealer_id"
            v-permission="Auth.productEdit"
            >编辑</el-button
          >
          <el-popconfirm
            v-permission="Auth.productDelete"
            title="确认删除吗？"
            @confirm="handleDelete(scope.$index, scope.row)"
            v-if="scope.row.dealer_id == userInfo.dealer_id"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="editItemCostPrice(scope.row, scope.$index)"
            v-if="scope.row.dealer_id != userInfo.dealer_id"
            v-permission="Auth.productEdit"
            >编辑成本价</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex-row-between mt-20">
      <div>
        <el-checkbox
          class="mr-10"
          style="margin-left: 14px"
          @change="toggleAllSelection"
          v-model="selectedAll"
          >{{ selectedAll ? '取消全选' : '全部选择' }}</el-checkbox
        >
        <el-button size="mini" type="danger" @click="batchDelete"
          >批量删除</el-button
        >
      </div>
      <div class="flex-row-base">
        <el-select
          v-model="filter.size"
          placeholder="请选择"
          size="mini"
          style="width: 100px; margin-right: 10px"
        >
          <el-option
            v-for="item in sizeOptions"
            :key="item"
            :label="'每页' + item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-pagination
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          @current-change="handlePageChange"
          :page-size="filter.size"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <part-editor
      :model="itemForm"
      :show.sync="itemEditorVisible"
      :showSupplier.sync="userInfo.dealer_id > 0"
      @created="createdItem"
      @updated="updatedItem"
    ></part-editor>

    <item-cost-price-former
      :model="itemForm"
      :show.sync="costPriceVisible"
      @updated="updatedItem"
    ></item-cost-price-former>
  </div>
</template>

<script>
import { itemList, deleteItem } from '@/service/getData'
import PartEditor from '@/components/part_editor'
import itemCostPriceFormer from '@/components/item_cost_price'
import { clone } from '@/util'
import store from '@/store/store'
import { itemBatchDelete } from '../../../service/getData'

export default {
  components: { PartEditor, itemCostPriceFormer },
  props: {
    filter: Object,
  },
  data() {
    return {
      loading: true,
      total: 0,
      lists: [],
      userInfo: {},
      itemForm: {
        cost_price: { price: 0 },
      },
      sizeOptions: [20, 50, 100],
      itemEditorVisible: false,
      costPriceVisible: false,
      itemEditIndex: -1,
      tableSelection: [],
      selectedAll: false,
    }
  },
  watch: {
    filter: {
      handler(newVal) {
        this.requestItemList()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.userInfo = store.state.userInfo
  },
  methods: {
    async requestItemList() {
      let data = clone(this.filter)
      data.page = data.page - 1
      this.loading = true
      let res = await itemList(data)
      if (res.code == 0) {
        this.lists = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestItemList()
    },
    startItemEditor(item, index) {
      if (item) {
        this.itemEditIndex = index
        let cloneItem = clone(item)
        cloneItem.items = []
        cloneItem.package = cloneItem.package == 1
        cloneItem.dealer = true
        cloneItem.machine_type = cloneItem.machine_type
          ? cloneItem.machine_type.split(',')
          : []
        this.itemForm = cloneItem
      } else {
        this.itemForm = {
          dealer: true,
          supplier_id: '',
          category: 1,
          item_category_id: '',
          part_number: '',
          name: '',
          description: '',
          price: 0,
          cost_price: { price: 0 },
          machine_type: [],
          items: [],
          package: false,
        }
      }
      this.itemEditorVisible = true
    },
    editItemCostPrice(item, index) {
      this.itemEditIndex = index
      this.costPriceVisible = true
      this.$nextTick(() => {
        this.itemForm = {
          id: item.id,
          name: item.name,
          cost_price: clone(item.cost_price),
        }
      })
    },
    createdItem(item) {
      this.lists.unshift(item)
    },
    updatedItem(item) {
      this.lists.splice(this.itemEditIndex, 1, item)
    },
    batchDelete() {
      if (this.tableSelection.length == 0) {
        return
      }
      let that = this
      this.$confirm(
        '是否确认批量删除所选' + this.tableSelection.length + '项',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        let ids = that.tableSelection.map((i) => {
          return i.id
        })
        itemBatchDelete({ ids: ids }).then((res) => {
          if (res.code == 0) {
            this.tableSelection = []
            this.selectedAll = false
            that.$message.success('删除成功')
            // that.filter.page -= 1
            // that.filter.page = Math.min(that.filter.page, 0)
            that.requestItemList()
          }
        })
      })
    },
    async handleDelete(index, item) {
      let res = await deleteItem(item.id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },
    toggleAllSelection() {
      this.$refs.table.toggleAllSelection(this.selectedAll)
    },
    handleSelectionChange(val) {
      this.tableSelection = val
      this.selectedAll = this.lists.length == val.length
    },
  },
}
</script>